import {useEffect, useState} from 'react'
import {useEmpreendimentos} from '../../../context/useEmpreendimentos'

import {ClearText, getYouTubeId} from '../../../../../../pages/explorer/components/common'

interface ImageType {
  dataURL: string
  type: string
  name: string
}

export function VideoCard() {
  const {launch, fetchLaunchByID} = useEmpreendimentos()

  const [videoList, setVideoList] = useState<ImageType[]>([])
  const [video, setVideo] = useState<File[]>([])

  const [videoUpload, setVideoUpload] = useState<[]>([])

  useEffect(() => {
    if (launch && launch.video && typeof launch.video === 'object') {
      // Transforme o objeto em um array de ImageType
      const imageArray = Object.keys(launch.video).map((key) => ({
        dataURL: launch.video[key].url,
        type: key.substring(key.indexOf('.') + 1, key.length),
        name: launch.video[key].description, // ou como você precisa mapear os valores
      }))

      setVideoList(imageArray)
    } else {
      setVideoList([])
    }
  }, [launch])

  const handleFileChange = (event) => {
    const selectedVideo = event.target.video
    if (selectedVideo && selectedVideo.length > 0) {
      const newVideo: File[] = Array.from(selectedVideo) as File[]
      setVideo((prevVideo) => [...prevVideo, ...newVideo])
    }
  }
  async function onSave() {
    const formData = new FormData()

    for (let i = 0; i < video.length; i++) {
      formData.append('video', video[i], ClearText(video[i]['name'])) // 'video[]' is a common convention for arrays on the server-side
    }

    // if (video) {
    //   video.forEach((item, index) => {
    //     // Convert base64 to Blob
    //     const arr = item.dataURL.split(',')
    //     const mime = arr[0].match(/:(.*?);/)?.[1] || ''
    //     const bstr = atob(arr[1])
    //     let n = bstr.length
    //     const u8arr = new Uint8Array(n)
    //     while (n--) {
    //       u8arr[n] = bstr.charCodeAt(n)
    //     }
    //     const blob = new Blob([u8arr], {type: mime})
    //     formData.append('video', blob, item.name)
    //   })
    // }
    // const response = await updateLaunchVideo(launch.id, formData)
    // console.log(response)
    // if (response) {
    //   fetchLaunchByID(launch.id)
    //   setVideo([])
    // }
  }
  const handleRemoveFile = (index: number) => {
    setVideo((prevVideo) => prevVideo.filter((_, i) => i !== index))
  }

  const handleDrop = (event) => {
    event.preventDefault()
    const droppedVideo = event.dataTransfer.video
    if (droppedVideo.length > 0) {
      const newVideo: File[] = Array.from(droppedVideo) as File[]
      setVideo((prevVideo) => [...prevVideo, ...newVideo])
    }
  }

  // useEffect(() => {
  //   setVideo(video)
  // }, [video])

  return (
    <div className='card flex-grow-1 mb-5 mb-xl-8'>
      <div className='card-header border-0 pt-5'>
        <h2 className='fw-bolder pt-4 px-8 m-0  flex-fill'>Vídeos</h2>

        {/* <input
          type='file'
          hidden
          id='browse'
          onChange={handleFileChange}
          accept='.pdf,.docx,.pptx,.txt,.xlsx'
          multiple
        />
        <label htmlFor='browse' className='btn btn-primary browse-btn me-3'>
          Procurar Arquivos
        </label>
        <button className='btn btn-sm btn-success' type='button' onClick={onSave}>
          Salvar
        </button> */}
      </div>
      <div className='card-body py-3'></div>
      <div className='row px-6'>
        <div
          className='form-group col-md-12  '
          onDrop={handleDrop}
          onDragOver={(event) => event.preventDefault()}
        >
          <div className='row g-6 g-xl-9 mb-6 mb-xl-9'>
            {videoList.map((image, index) => {
              return (
                <>
                  <div className='col-6 col-sm-6  ' style={{height: 500}}>
                    <div className='card '>
                      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                        <div className='mb-6'>
                          <iframe
                            style={{height: 500}}
                            width='520'
                            height='415'
                            src={`https://www.youtube.com/embed/${getYouTubeId(image.dataURL)}`}
                            title={`YouTube video player - ${image.name}`}
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            referrerPolicy='strict-origin-when-cross-origin'
                            allowFullScreen
                          ></iframe>

                          {/* <iframe
                            style={{height: 500}}
                            width='520'
                            height='415'
                            src={image.dataURL}
                            title={`video-${index}-${image.name}`}
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            referrerpolicy='strict-origin-when-cross-origin'
                            allowfullscreen
                          ></iframe> */}
                        </div>
                        <div className='fs-5 fw-bolder mb-2'>{image.name}</div>
                      </div>
                    </div>
                  </div>
                </>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
